import Autolinker from 'autolinker';

export const removeAccents = (s) => {
  const r = {
    À: 'A',
    Á: 'A',
    Â: 'A',
    Ã: 'A',
    Ä: 'A',
    Å: 'A',
    Æ: 'E',
    È: 'E',
    É: 'E',
    Ê: 'E',
    Ë: 'E',
    Ì: 'I',
    Í: 'I',
    Î: 'I',
    Ò: 'O',
    Ó: 'O',
    Ô: 'O',
    Ö: 'O',
    Ù: 'U',
    Ú: 'U',
    Û: 'U',
    Ü: 'U',
    Ñ: 'N',
  };

  return s.replace(/[ÀÁÂÃÄÅÆÈÉÊËÌÍÎÒÓÔÖÙÚÛÜÑ]/gi, (m) => {
    let ret = r[m.toUpperCase()];

    if (m === m.toLowerCase()) {
      ret = ret.toLowerCase();
    }

    return ret;
  });
};

export const getTitleSize = (text) => {
  let fontSize = 32;
  const lenStr = text.length;

  if (lenStr > 80) {
    fontSize = 22;
  } else if (lenStr > 40) {
    fontSize = 28;
  }

  return fontSize;
};

export const fromHtmlEntities = string => string.replace(/&#\d+;/gm, s => String.fromCharCode(s.match(/\d+/gm)[0]));

export const toHtmlEntities = string => string.replace(/./gm, (s) => {
  return (s.match(/[a-z0-9\s]+/i)) ? s : `&#${s.charCodeAt(0)};`;
});

export const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1);

export const parseTags = (msg) => {
  const message = Autolinker.link(msg, {
    stripPrefix: false,
    className: 'link',
    sanitizeHtml: true,
  });
  const arrayMessage = message.split('');
  let count = arrayMessage.filter(c => c === '*').length;

  if (count < 2) {
    return message;
  }

  if (count % 2 === 1) {
    count -= 1;
  }

  while (count > 0) {
    const index = arrayMessage.indexOf('*');

    if (count % 2 === 0) {
      arrayMessage.splice(index, 1, '<strong>');
    } else {
      arrayMessage.splice(index, 1, '</strong>');
    }
    count -= 1;
  }

  const newMessage = arrayMessage.join('');

  return newMessage;
};



// WEBPACK FOOTER //
// ./src/utils/string.js